<div class="notifications-holder">
    <ng-container *ngIf="notifications.length > 0">
        <ng-container *ngFor="let notification of notifications">
            <div class="notification-wrap">
                <notification [notification]="notification" [practice]="currentPractice$ | async"></notification>
            </div>
        </ng-container>
    </ng-container>
</div>
